import React from 'react'
import { useDrawingArea } from '@mui/x-charts'
import { ChartsTextProps } from '@mui/x-charts/ChartsText'
import { DatasetType } from '@mui/x-charts/internals'

export const AxisTickLabel = (props: ChartsTextProps & { diagramDataSet?: DatasetType }) => {
  const { width } = useDrawingArea()
  const { diagramDataSet: ds, text: rawText, ...rest } = props as any
  const labelsCount = ds?.length ?? 0

  const maxLabelWidth = labelsCount > 0 ? Math.floor((width * 0.7) / labelsCount) : 15

  const maxChars = Math.max(8, Math.floor(maxLabelWidth / 8))

  const truncateMiddle = (value: string, limit: number) => {
    if (value.length <= limit) return value
    if (limit <= 3) return value.slice(0, limit)

    const keep = limit - 3
    const keepStart = Math.ceil(keep / 2)
    const keepEnd = Math.floor(keep / 2)

    return `${value.slice(0, keepStart)}...${value.slice(-keepEnd)}`
  }

  const truncateRange = (value: string, limit: number) => {
    const separator = ' - '
    if (!value.includes(separator)) return truncateMiddle(value, limit)

    const [fromRaw, toRaw] = value.split(separator)
    const from = fromRaw.trim()
    const to = toRaw.trim()
    const budget = limit - separator.length

    if (budget < 10) return truncateMiddle(value, limit)

    const partLimit = Math.floor(budget / 2)
    const truncatedFrom =
      from.length > partLimit ? `${from.slice(0, Math.max(1, partLimit - 3))}...` : from
    const truncatedTo = to.length > partLimit ? `...${to.slice(-Math.max(1, partLimit - 3))}` : to

    return `${truncatedFrom}${separator}${truncatedTo}`
  }

  const label = String(rawText ?? '')
  const text = truncateRange(label, maxChars)

  return (
    <text {...rest} textAnchor='middle'>
      <title>{label}</title>
      {text}
    </text>
  )
}
